import React from 'react';

const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
    <path
      d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.85333 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoIcon;
